// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"535":"659d688aecf15c7c","888":"0156fde123613809"}[chunkId] + ".css";
};